import Button from "./button/button";
import ModuleSearch from "./modulesearch/modulesearch";
import Multiple from "./multiple/multiple";
import Pagination from "./pagination/pagination";
import Submit from "./submit/submit";
import Text from "./text/text";
import Tabs from "./tabs/tabs";
import ValidationControl from "./validationControl/validationControl";
import Module from "./module/module";
import Editor from "./editor/editor";
import Hidden from "./hidden/hidden";
import Select from "./select/select";
import Textarea from "./textarea/textarea";
import Datetime from "./datetime/datetime";
import Tag from "./tag/tag";
import Tree from "./tree/tree";
import Placeholder from "./placeholder/placeholder";
import Upload from "./upload/upload";
import ExportCSV from "./exportcsv/exportcsv";

const Controls = {
  text: Text,
  submit: Submit,
  validationcontrol: ValidationControl,
  multiple: Multiple,
  button: Button,
  pagination: Pagination,
  modulesearch: ModuleSearch,
  tabs: Tabs,
  module: Module,
  editor: Editor,
  hidden: Hidden,
  select: Select,
  textarea: Textarea,
  datetime: Datetime,
  tag: Tag,
  tree: Tree,
  placeholder: Placeholder,
  upload: Upload,
  exportcsv: ExportCSV,
};

export default Controls;
